var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"question-container"},[_c('div',{staticClass:"question"},[_c('wes-question',{attrs:{"question":_vm.question,"qId":_vm.question.displayId,"isStandardSurvey":_vm.isStandardSurvey},on:{"update-status":_vm.onUpdateStatus}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }